import React from "react";
import {
  FETCH_SELECTED_PROJECT_DATA_PENDING,
  FETCH_SELECTED_PROJECT_DATA_SUCCESS,
  FETCH_SELECTED_PROJECT_DATA_ERROR,
  FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING,
  FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR,
  FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS,
  API_URL,
  HOST_URL,
  POST_PROJECT_DATA,
  POST_PROJECT_DATA_SUCCESS,
  POST_PROJECT_DATA_ERROR,
  POST_CALCULATIONS,
  POST_CALCULATIONS_ERROR,
  POST_CALCULATIONS_SUCCESS,
  FETCH_REPORTS_CONFIG_SUCCESS,
  FETCH_REPORTS_CONFIG_PENDING,
  FETCH_REPORTS_CONFIG_ERROR,
  ISSUE_URL,
} from "../../helpers/constants/Constants";
import { connect } from "react-redux";
import { requestData } from "../../helpers/axios/Get";
import {
  getSelectedProject,
  properties,
  getSelectedModelArray,
  updateAdditionalTabs,
  getReviewId,
} from "../../helpers/actions/Action";
import { postRequest } from "../../helpers/axios/Post";
import Select from "react-select";
import store from "../../helpers/store/Store";

class ProjectFinder extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedOption: null,
    };
  }

  componentDidUpdate(prevProps) {
    //If there was a change set state.
    //This currently doesnt trigger a data load so is open to be changed.
    if (this.props.selected != prevProps.selected) {
      this.setState({selectedOption: this.props.selected});
    }
  }

  nameShortening = (text) => {
    let maxLength = this.props.settings.maxProjectFinderNameLength;
    let shortendName =
      text.length >= maxLength ? text.substring(0, maxLength) + "..." : text;
    return shortendName;
  };

  handleChange = (selectedOption) => {
    store.dispatch(updateAdditionalTabs(true));
    store.dispatch(properties(null));
    store.dispatch(getSelectedModelArray([]));
    store.dispatch(getReviewId(null));
    this.setState({ selectedOption }, () => {
      this.props.onrequestSelectedProjectDataReducer(
        this.state.selectedOption.id,
        { withCredentials: true }
      );
      this.props.onrequestIssuesDataReducer(
        this.state.selectedOption.projectid,
        { withCredentials: true }
      );
      this.props.selectedProject(this.state.selectedOption);
      this.props.onrequestPostProjectData({
        method: "post",
        url: HOST_URL + "/api/getprojectinput",
        headers: { "content-type": "application/json" },
        withCredentials: true,
        data: {
          projectid: this.state.selectedOption.projectid,
        },
      });
      this.props.onrequestPostCalculations({
        method: "post",
        url: HOST_URL + "/api/getcalculationdata",
        headers: { "content-type": "application/json" },
        withCredentials: true,
        data: {
          projectid: this.state.selectedOption.projectid,
        },
      });
      this.props.onrequestReportsConfig(this.state.selectedOption.projectid);
    });
  };

  render() {
    const { selectedOption } = this.state;
    return (
      <div id="theProjectFinder">
        <Select
          classNamePrefix={"typeahead-select"}
          value={selectedOption}
          onChange={this.handleChange}
          options={this.props.data}
          getOptionLabel={(option) => this.nameShortening(option.text)}
          getOptionValue={(option) => option.text}
          placeholder="Select project"
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.requestProjectsDataReducer.data,
  selected: state.getSelectedProjectReducer.data,
  settings: state.requestGeneralSettingsReducer.data,
});

const mapDispatchToProps = (dispatch) => {
  return {
    selectedProject: (selected) => {
      dispatch(getSelectedProject(selected));
    },
    onrequestSelectedProjectDataReducer: (id, config) =>
      dispatch(
        requestData(
          API_URL + "?id=" + id,
          {
            pending: FETCH_SELECTED_PROJECT_DATA_PENDING,
            error: FETCH_SELECTED_PROJECT_DATA_ERROR,
            success: FETCH_SELECTED_PROJECT_DATA_SUCCESS,
          },
          config
        )
      ),
    onrequestIssuesDataReducer: (id, config) =>
      dispatch(
        requestData(
          ISSUE_URL + id,
          {
            pending: FETCH_SELECTED_PROJECT_ISSUES_DATA_PENDING,
            error: FETCH_SELECTED_PROJECT_ISSUES_DATA_ERROR,
            success: FETCH_SELECTED_PROJECT_ISSUES_DATA_SUCCESS,
          },
          config
        )
      ),
    onrequestPostProjectData: (config) =>
      dispatch(
        postRequest(
          {
            pending: POST_PROJECT_DATA,
            error: POST_PROJECT_DATA_ERROR,
            success: POST_PROJECT_DATA_SUCCESS,
          },
          config
        )
      ),
    onrequestPostCalculations: (config) =>
      dispatch(
        postRequest(
          {
            pending: POST_CALCULATIONS,
            error: POST_CALCULATIONS_ERROR,
            success: POST_CALCULATIONS_SUCCESS,
          },
          config
        )
      ),
    onrequestReportsConfig: (id) =>
      dispatch(
        requestData(
          "/config/reports/" + id.replace("b.", "") + "/reports_config.json",
          {
            success: FETCH_REPORTS_CONFIG_SUCCESS,
            pending: FETCH_REPORTS_CONFIG_PENDING,
            error: FETCH_REPORTS_CONFIG_ERROR,
          }
        )
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectFinder);
